import React from "react";
import { useStats } from "react-instantsearch";

export default function CustomStats() {
  const { nbHits, page, hitsPerPage } = useStats();

  if (nbHits === 0) {
    return <div className="sui-stats">Aucun résultat trouvé</div>;
  }

  const start = page * hitsPerPage + 1;
  const end = Math.min((page + 1) * hitsPerPage, nbHits);

  return (
    <div className="sui-stats" style={{ fontSize: "14px", color: "#666" }}>
      Affichage de {start} - {end} sur <strong>{nbHits.toLocaleString("fr-CH")}</strong> résultats
    </div>
  );
}
